import React from "react";

// utils
import { moneyFormatter } from "../../js/common";

// types
import { BannerProps } from "./types";

const Banner = ({ details }: BannerProps) => {
  const handleOpenUrl = () => {
    if (window.ReactNativeWebView) {
      const data = JSON.stringify({
        type: "openExternalLink",
        link: details.url,
      });
      window.ReactNativeWebView.postMessage(data);
    } else {
      window.location.href = details.url;
    }
  };

  return (
    <div className="banner" onClick={handleOpenUrl}>
      <img src={details?.imgUrl} />

      <span className="title">{details?.title}</span>
      {details?.discountRate === 0 ? (
        <div>
          <span className="discount">{moneyFormatter(details?.discountedPrice)}</span>
        </div>
      ) : (
        <>
          <div>
            <span className="percent">{`${details?.discountRate}%`}</span>
            <span className="discount">{moneyFormatter(details?.discountedPrice)}</span>
          </div>
          <span className="price">{moneyFormatter(details?.price)}</span>
        </>
      )}
    </div>
  );
};

export default Banner;
